import { PieTooltipProps, ResponsivePie } from "@nivo/pie";
import React from "react";

export interface CircleGraphItem {
  color: string;
  id: string;
  label: string;
  value: number;
}

export function DonutChart({
  data,
  innerRadius,
  isInteractive = true,
  tooltipElement,
}: {
  data: CircleGraphItem[];
  innerRadius?: number;
  isInteractive?: boolean;
  tooltipElement?: React.FC<PieTooltipProps<CircleGraphItem>>;
}) {
  return (
    <ResponsivePie
      colors={{ datum: "data.color" }}
      data={data}
      enableArcLabels={false}
      enableArcLinkLabels={false}
      innerRadius={innerRadius}
      isInteractive={isInteractive}
      sortByValue={true}
      tooltip={tooltipElement}
    />
  );
}
